export const defaultValuesProductForm = (currentProduct: Partial<any> | undefined) => ({
  items: currentProduct?.items || [],
});
